module.exports = __webpack_public_path__ + "img/portrait-008.99e1e98f.jpg";